interface OperatorSeparatorProps {
  text: string;
  colorClass: string; // e.g., 'sky-500', 'primary'
}

/**
 * Displays a vertical line and text (like 'and' or 'or') typically used
 * between conditions in a list.
 */
export function OperatorSeparator({ text, colorClass }: OperatorSeparatorProps) {
  const borderColorClass = `border-${colorClass}`;
  const textColorClass = `text-${colorClass}`;

  return (
    <div className={`flex items-center justify-start py-1 pl-2 border-l-2 ${borderColorClass}`}>
      <span className={`text-md ${textColorClass}`}>{text}</span>
    </div>
  );
}
